import * as React from 'react';
import { renderText } from '../../assistent_helpers';
import style from '../../Assistent.less';

interface HinweiseElementVsmeProps extends React.ClassAttributes<any> {
    data: any;
    textKey: string;
    stlye?: React.CSSProperties;
}

export class HinweiseElementVsme extends React.Component<HinweiseElementVsmeProps, {}> {

    constructor(props: any) {
        super(props);
        this.state = {};
    }

    render(): JSX.Element {
        return (
            <div
                className={style.customFormInfotext}
                style={this.props.stlye}
            >
                {this.renderText()}
            </div>
        );
    }

    renderText(): JSX.Element | JSX.Element[] {
        const html: JSX.Element = renderText(this.props.textKey, this.props.data);
        return html;
    }
}
